import React from 'react';
import { Wrench, Network, Cloud, BrainCircuit, Briefcase, Sparkles } from 'lucide-react';
import { coursesData } from '../mock';

const iconMap = {
  Wrench,
  Network,
  Cloud,
  BrainCircuit,
  Briefcase
};

const Courses = () => {
  return (
    <section id="courses" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What You'll Master
          </h2>
          <div className="section-underline"></div>
          <p className="text-xl text-gray-600">
            Five cutting-edge tracks designed to get you job-ready fast
          </p>
        </div>

        {/* Course Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {coursesData.map((course) => {
            const Icon = iconMap[course.icon];
            return (
              <div 
                key={course.id} 
                className="course-card"
                style={{ color: `var(--tw-gradient-from)` }}
              >
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${course.gradient} flex items-center justify-center mb-4 shadow-lg`}>
                  <Icon className="text-white" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {course.title}
                </h3>
                <p className="text-gray-600">
                  {course.description}
                </p>
              </div>
            );
          })}

          {/* Coming Soon Card */}
          <div className="course-card border-dashed" style={{ color: '#d1d5db' }}>
            <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
              <Sparkles className="text-gray-400" size={28} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              More courses coming soon!
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Courses;